import { h, defineComponent, SetupContext } from 'vue';
// @ts-ignore
import { BRadioButton } from 'buefy/dist/esm/radio';
import { ValidationError } from '@/entities/validation';
import { Field, FieldProps } from './Field';

export interface RadioButtonFieldProps {
  name: string;
  label: string;
  value: boolean;
  required: boolean;
  disabled: boolean;
  errors: ValidationError[];
  hideLabel?: boolean;
  nativeValue?: string | number;
}

export const RadioButtonField = defineComponent<RadioButtonFieldProps>({
  name: 'RadioButtonField',
  props: [
    'name', 'label', 'value', 'required', 'errors', 'disabled',
    'hideLabel', 'nativeValue',
  ],
  setup(props, context: SetupContext) {
    const newFeatureWrapper = () => context.slots.newFeature?.();

    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors ?? [],
        hideLabel: props.hideLabel ?? true,
      };

      return h(Field, { props: fieldProps }, [
        h(BRadioButton, {
          props: { value: props.value, nativeValue: props.nativeValue },
          attrs: {
            ...context.attrs,
            name: props.name,
            disabled: props.disabled,
          },
          on: {
            input: (newValue: boolean) => {
              context.emit('input', newValue);
            },
          },
        }, [h('span', props.label)]),
        newFeatureWrapper(),
      ]);
    };
  },
});
